import React, { useState, useEffect } from 'react';
import Icon from './AppIcon';

const NotificationBanner = ({ message, type = 'warning', onDismiss }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const dismissed = localStorage.getItem('notification-banner-dismissed');
    if (dismissed) {
      setIsVisible(false);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('notification-banner-dismissed', 'true');
    if (onDismiss) {
      onDismiss();
    }
  };

  if (!isVisible) {
    return null;
  }

  const getIcon = () => {
    switch (type) {
      case 'warning':
        return 'AlertTriangle';
      case 'error':
        return 'AlertCircle';
      case 'success':
        return 'CheckCircle';
      default:
        return 'Info';
    }
  };

  return (
    <div className={`notification-banner ${!isVisible ? 'hidden' : ''}`}>
      <div className="notification-banner-content">
        <div className="notification-banner-icon">
          <Icon name={getIcon()} size={20} />
        </div>
        <p className="notification-banner-text">{message}</p>
      </div>
      <button
        onClick={handleDismiss}
        className="notification-banner-close"
        aria-label="Dismiss notification"
      >
        <Icon name="X" size={18} />
      </button>
    </div>
  );
};

export default NotificationBanner;